<style scoped>
    .vue-modal {
        display: block;
    }
</style>
<template>
    <div style="display:inline-block">
        <button
                class="btn btn-primary btn-sm"
                @click="showCompositionList()"
                :title="trans('show_composition_list')"> <i class="fa fa-list"></i> </button>
        <button
                class="btn btn-primary btn-sm"
                @click="downloadCompositionList()"
                :title="trans('download_composition_list')"> <i class="fa fa-file-excel-o"></i> </button>
        <button
                class="btn btn-primary btn-sm"
                @click="getInvoicePdf()"
                :title="trans('show_invoice_pdf')"> <i class="fa fa-file-pdf-o"></i> </button>
        <button
                class="btn btn-primary btn-sm"
                @click="getInvoiceExcel()"
                :title="trans('download_invoice_excel')"> <i class="fa fa-file-excel-o"></i> </button>
        <button
                class="btn btn-primary btn-sm"
                @click="showStickersDateChoice()"
                :title="trans('show_stickers')"> <i class="fa fa-image"></i> </button>

        <div class="modal vue-modal" v-show="show_stickers_date_choice">
            <div class="modal-dialog">
                <div class="modal-content">

                    <div class="modal-header">
                        <button type="button" class="close" @click="show_stickers_date_choice = false" aria-label="Close">
                            <span aria-hidden="true">&times;</span></button>
                        <h4 class="modal-title"  v-text="trans('stickers.modal_title')"></h4>
                    </div>

                    <div class="modal-body">
                        <p class="lead text-mutted" v-text="trans('stickers.modal_info')"></p>
                        <input type="text" name="date" v-model="stickers_date" id="datepicker_start" class="form-control">
                    </div>

                    <div class="modal-footer">
                        <button type="button"
                                @click="getStickers()"
                                v-show="stickers_date"
                                style="margin-left: 15px;"
                                class="btn btn-success pull-right"
                                v-text="trans('apply_button', null)"
                        ></button>
                        <button type="button"
                                class="btn btn-danger pull-right"
                                v-text="trans('cancel_button', null)"
                                @click="show_stickers_date_choice = false"
                        ></button>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import * as Functions from '../Functions';

    export default {
        props: ['permission_for_search_application', 'requisites', 'current_date', 'translations'],
        data: function () {
            return {
                checked: [],
                stickers_date: this.current_date,
                chosen_requisite: 0,
                show_stickers_date_choice: false,
            };
        },
        ready: function() {
            Vue.http.headers.common['X-CSRF-TOKEN'] = document.querySelector('#token').getAttribute('content');
        },
        mounted: function () {
            $("#datepicker_start").on(
                "changeDate", () => {this.stickers_date = document.getElementById('datepicker_start').value}
            );
        },
        methods: {
            trans(name, path = 'print_controls') {
                return Functions.trans(this.translations, name, path);
            },
            showCompositionList: function () {
                if (this.checked.length < 1) {
                    return this.orderNotFound();
                }

                this.openWithPost('/shop/compensation/composition_list/show', {ids: this.checked});
            },
            downloadCompositionList: function () {
                if (this.checked.length < 1) {
                    return this.orderNotFound();
                }

                this.openWithPost('/shop/compensation/composition_list/download', {ids: this.checked});
            },
            showStickersDateChoice: function () {
                if (this.checked.length < 1) {
                    return this.orderNotFound();
                }
                this.show_stickers_date_choice = true;
            },
            getStickers: function () {
                this.openWithPost('/shop/compensation/stickers', {
                    ids: this.checked,
                    date: this.stickers_date
                });
            },
            getInvoicePdf: function () {
                if (this.checked.length < 1) {
                    return this.orderNotFound();
                }

                this.openWithPost('/shop/compensation/invoice/pdf', {ids: this.checked});
            },
            getInvoiceExcel: function () {
                if (this.checked.length < 1) {
                    return this.orderNotFound();
                }

                this.openWithPost('/shop/compensation/invoice/excel', {ids: this.checked});
            },

            orderNotFound: function () {
                alert(this.trans('orders_not_selected', null));
            },
            openWithPost: function(url, data) {
                let form = document.createElement("form");
                form.action = url;
                form.method = 'POST';
                form.target = "_blank";

                for (let key in data) {
                    this.appendInputToForm(form, key, data[key]);
                }
                this.appendInputToForm(form, '_token', document.querySelector('#token').getAttribute('content'));

                form.style.display = 'none';
                document.body.appendChild(form);
                form.submit();
            },
            appendInputToForm: function (form, key, value) {
                let input = document.createElement("textarea");
                input.name = key;
                input.value = typeof value === "object" ? JSON.stringify(value) : value;
                form.appendChild(input);
            }
        },
        created: function () {
            this.$root.$on('update:checked', (val) => { this.checked = val});
        }
    }
</script>
